import type { PayPalCheckoutItem } from '@/components/PayPalButton/PayPalForm';

export const GST_RATE = 0.05;

export const parsePrice = (price?: string): number => {
  const numeric = Number.parseFloat((price ?? ``).replace(/[^\d.]/g, ``));
  return Number.isFinite(numeric) ? numeric : 0;
};

export const formatCurrency = (amount: number): string =>
  amount.toLocaleString(`en-CA`, {
    style: `currency`,
    currency: `CAD`,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const getCartItemKey = (item: PayPalCheckoutItem): string => {
  const bundleKey = item.bundleSelections
    ? `${item.bundleSelections.firstBook}-${item.bundleSelections.secondBook}`
    : ``;
  return `${item.hostedButtonId}:${bundleKey}`;
};
